import LoginForm from "../../components/form/LoginForm"

export default function Login() {
  return (
      <div className="m-auto w-[80%] space-y-4">
        <h1 className="font-[Phudu] text-primary font-black text-[2em]">Login</h1>
        <LoginForm />
      </div>

  )
}
